/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery,
  type DataTag,
  type MutationFunction,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationReturnType,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useMutationOptions } from ".././mutationOptions.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type {
  AlertsResponse,
  DeactivateAlertRequest,
  Error,
  GetAlertsAndBannersParams,
} from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get the alerts and marketing banners that are active for this account
 */
export const getAlertsAndBanners = (
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetAlertsAndBannersParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  params = toValue(params)

  return customInstance<AlertsResponse>(
    {
      url: `/api/v1/accounts/${accountId}/alerts-banners`,
      method: "GET",
      params,
      signal,
    },
    options,
  )
}

export const getGetAlertsAndBannersQueryKey = (
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetAlertsAndBannersParams>,
) => {
  return [
    "api",
    "v1",
    "accounts",
    accountId,
    "alerts-banners",
    ...(params ? [params] : []),
  ] as const
}

export const useGetAlertsAndBannersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAlertsAndBanners>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetAlertsAndBannersParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAlertsAndBanners>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetAlertsAndBannersQueryKey(accountId, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAlertsAndBanners>>
  > = ({ signal }) =>
    getAlertsAndBanners(accountId, params, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId, params },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getAlertsAndBanners>>,
    TError,
    TData
  >
}

export type GetAlertsAndBannersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAlertsAndBanners>>
>
export type GetAlertsAndBannersQueryError = ErrorType<Error>

/**
 * @summary Get the alerts and marketing banners that are active for this account
 */

export function useGetAlertsAndBanners<
  TData = Awaited<ReturnType<typeof getAlertsAndBanners>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetAlertsAndBannersParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAlertsAndBanners>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetAlertsAndBannersQueryOptions(
    accountId,
    params,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Deactivate an alert
 */
export const deactivateAlert = (
  accountId: MaybeRefOrGetter<number>,
  deactivateAlertRequest: MaybeRefOrGetter<DeactivateAlertRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  deactivateAlertRequest = toValue(deactivateAlertRequest)

  return customInstance<AlertsResponse>(
    {
      url: `/api/v1/accounts/${accountId}/alerts/deactivate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deactivateAlertRequest,
      signal,
    },
    options,
  )
}

export const useDeactivateAlertMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateAlert>>,
    TError,
    { accountId: number; data: DeactivateAlertRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateAlert>>,
  TError,
  { accountId: number; data: DeactivateAlertRequest },
  TContext
> => {
  const mutationKey = ["deactivateAlert"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateAlert>>,
    { accountId: number; data: DeactivateAlertRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return deactivateAlert(accountId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type DeactivateAlertMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivateAlert>>
>
export type DeactivateAlertMutationBody = DeactivateAlertRequest
export type DeactivateAlertMutationError = ErrorType<Error>

/**
 * @summary Deactivate an alert
 */
export const useDeactivateAlert = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deactivateAlert>>,
      TError,
      { accountId: number; data: DeactivateAlertRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deactivateAlert>>,
  TError,
  { accountId: number; data: DeactivateAlertRequest },
  TContext
> => {
  return useMutation(useDeactivateAlertMutationOptions(options), queryClient)
}
